// extracted by mini-css-extract-plugin
export default {"statistics":"Statistics_statistics__MHVAH"};